export function DocumentMention({ title }: { title: string }) {
	return (
		<span className="border-cv-accent-mention-border bg-cv-accent-mention text-cv-accent inline-flex items-center gap-1 rounded border px-1.5 align-middle text-[11px] font-medium">
			<span className="bg-cv-accent h-1.5 w-1.5 shrink-0 rounded-full opacity-70" />
			{title}
		</span>
	);
}
